export default () => ({
  root: {
    width: 800,
  },
});
